$(document).ready(function() {
    // Set all .js-card-height elements to the same height
    function setSameHeight() {
        var maxHeight = 0;
        $('.js-card-height').each(function() {
            maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });
        $('.js-card-height').css('height', maxHeight + 'px');
    }

    // Call setSameHeight function on page load and window resize
    setSameHeight();
    $(window).resize(function() {
        $('.js-card-height').css('height','0px');
        setSameHeight();
    });
});